<!-- 保利录播 -->
<template>
  <div id="player" class="height-100 width-100"></div>
</template>
<script>
import { loadJs } from '@/utils/domUtil.js'
export default {
  data() {
    return {
      player: null,
      playerJsSrc: 'https://player.polyv.net/script/player.js',
    }
  },
  props: {
    plVid: {
      type: String,
      default: '',
    },
    watchStartTime: {
      type: [String, Number],
      default: 0,
    },
  },
  created() {
    if (!window.polyvPlayer) {
      loadJs(this.playerJsSrc, this.loadPlayer)
    } else {
      this.loadPlayer()
    }
  },
  destroyed() {
    this.player && this.player.destroy()
  },
  methods: {
    loadPlayer(isShowControl = true) {
      this.$nextTick(async () => {
        const playsafe = await this.$http.get(`/b/material/web/matVideo/playToken/${this.plVid}`)
        const polyvPlayer = window.polyvPlayer
        const vid = this.plVid
        this.player = polyvPlayer({
          wrap: '#player',
          width: '100%',
          height: '100%',
          vid: vid,
          pictureInPicture: true, // 画中画
          showHd: true,
          ban_history_time: 'off',
          df: 3,
          playsafe: playsafe,
          autoplay: true,
          watchStartTime: this.watchStartTime,
          ban_ui: isShowControl ? 'off' : 'on'
        })
        const that = this
        this.player.on('s2j_onPlayerInitOver', function (e) {
          that.$emit('onPlayerInitOver', that.player.j2s_getDuration(), e)
        })
        this.player.HTML5.on('videoTimeupdate', function (e) {
          const currentTime = that.player && that.player.j2s_getCurrentTime ? that.player.j2s_getCurrentTime() : 0
          that.$emit('videoTimeupdate', currentTime, e)
        })
        this.player.on('s2j_onVideoPlay', function (e) {
          that.$emit('onVideoPlay')
        })
        this.player.on('s2j_onVideoPause', function (e) {
          that.$emit('onVideoPause')
        })
      })
    },
    // 跳到指定位置
    seek(value) {
      this.player && this.player.j2s_seekVideo(value)
    },
    // 播放视频
    play() {
      this.player && this.player.j2s_resumeVideo()
    },
    // 暂停视频
    pause() {
      console.log('pause', this.player)
      this.player && this.player.j2s_pauseVideo()
    },
    // 切换清晰度
    switchBitrate(value) {
      const params = {
        自动: 0,
        流畅: 1,
        高清: 2,
        超清: 3,
      }
      const bitrate = params[value.type] || value.type
      this.player && this.player.switchBitrate(bitrate || 0)
    },
    // 切换速率
    changeRate(value) {
      this.player && this.player.changeRate(value)
    },
    toggleFullscreen() {
      // this.player && this.player.toggleFullscreen()
      console.log(this.player)
      // this.loadPlayer(true)
    },
  },
}
</script>
<style lang="less" scoped>
@import './player.css';
</style>
